/* React hooks */
import {useEffect, useState, useMemo} from "react";
/* Components*/
import useData from "../../hooks/useData";
import { getEstimateSectionList, updateEstimateSection} from "../../api/admin/estimateReq";
import useAuth from "../../hooks/useAuth";
import FormButtons from "../../components/common/FormButtons";
import {getErrorListFromValidation, patternListChoices, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormSectionUpdate({ section, legend, setShowUpdateModal }) {

    const { auth } = useAuth();
    const token = auth.token;
    const { estimateSectionList, setEstimateSectionList } = useData();
    const [values, setValues] = useState();

    const filteredSection = useMemo(() => {
        return estimateSectionList?.find(apiSection => apiSection?.id === section);
    }, [estimateSectionList, section]);

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
        setEstimateSectionList(response)
    }

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const handleSubmit = (e) => {
        e.preventDefault()

        const sectionExists = estimateSectionList?.some(
            apiSection => apiSection.section.toUpperCase() === values?.section?.toUpperCase()
                && apiSection.section !== filteredSection?.section
        );

        if (sectionExists) {
            alert(`La section ${values.section} existe déjà. Veuillez choisir un autre numéro.`);
            return;
        }

        let body = {
            id: filteredSection?.id,
            description: values?.description,
            section: values?.section?.toUpperCase(),
            oldSection: filteredSection?.section,
        }

        return (updateEstimateSection(token, body)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    apiEstimateSectionList()
                    setShowUpdateModal(false)
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            }))

    }

    useEffect(() => {
        apiEstimateSectionList()
    }, [ token ]);

    useEffect(() => {
        setValues(filteredSection)
    }, [ filteredSection ]);

    const handleRemoveModal = (e) => {
        setShowUpdateModal(false)
    };

        return (
            <form onSubmit={handleSubmit} method="post" noValidate>
                <fieldset>
                    <Icon span="Modification d'une section" source="fa fa-list-ol" />               <div className="form-input">
                        <label htmlFor="section">Numéro de section (obligatoire)</label>
                        <input
                            type="text"
                            name="section"
                            pattern={patternListChoices?.section}
                            defaultValue={filteredSection?.section}
                            onChange={onChange}
                            placeholder="Ex: 8, 7A, 7B, 10A..."
                            required
                        />
                        <small>Format: nombre + lettre optionnelle (ex: 7, 7A, 7B, 10A)</small>
                    </div>
                    <div className="form-input">
                        <label htmlFor="description">Description (obligatoire)</label>
                        <textarea
                            name="description"
                            defaultValue={filteredSection?.description}
                            onChange={onChange}
                            required
                        />
                    </div>
                    <div className="errors"></div>
                    <FormButtons handleRemoveModal={handleRemoveModal}/>
                </fieldset>
            </form>
    )
}